import React from 'react'
import TopProspectImage from "../../assets/top_prospect.svg";
import GreyArrowDown from "../../assets/GreyArrowDown.svg";
import ConditionalRender from '../../ConditionalRender';
import { useReducer } from 'react';
import { useEffect } from 'react';
import { apiAgent } from '../../axiosConfig';
import getApiUrl from '../utils/UrlHelper';
import { useCallback } from 'react';
import { Loader } from '../../design_system/components/Loader.jsx';
import { TextHighlighter } from '../utils/textHighlighter';
import Seemore from '../utils/SeemoreUtils';
import { Link } from 'react-router-dom';
import AiSummaryBox from './AiSummaryBox.jsx';
import { handleNewsImageError } from '../utils/newsImageFallback.js';

const ClubbedPost = (props) => {
    const [clubbedData, setClubbedData] = useReducer(reducer, {
        posts: [],
        isLoading: {}
    })
    const fetchClubbedPosts = useCallback(() => {
        setClubbedData({type: "SET_STATE", payload: {isLoading: {fetchingPosts: true}}})
        apiAgent({
            method: "get",
            url: getApiUrl("get_clubbed_posts"),
            params: {post_id: props.item.id}
        }).then(res => {
            setClubbedData({type: "SET_STATE", payload: {posts: res.data.data, isLoading: {}}})
        }).catch(err => {
            setClubbedData({type: "SET_STATE", payload: {isLoading: {}}})
        })
    }, [props.item.id])

    useEffect(() => {
        if(props.expanded === true && clubbedData.posts.length === 0){
            fetchClubbedPosts();
        }
    }, [props.expanded, clubbedData.posts, fetchClubbedPosts])

    return (
        <>
            <ConditionalRender if={props.expanded === false}>
                <div className="px-xl flex justify-between items-center">
                    <div className="flex items-center">
                        <img src={TopProspectImage} className="newsfeed__clubbed-icon"></img>
                        <div className="body-m-semibold newsfeed__clubbed-featured-text">{props.item.tagged_prospects?.[0]?.name || "This prospect"} frequently gets featured in news.</div>
                    </div>
                    <div className="flex items-center cursor-pointer" onClick={props.toggleExpansionCallback}>
                        <div className="body-m-semibold newsfeed__clubbed-toggle-text">Click here to view articles</div>
                        <img src={GreyArrowDown}></img>
                    </div>
                </div>
            </ConditionalRender>
            <ConditionalRender if={props.expanded}>
                <ConditionalRender if={clubbedData.isLoading.fetchingPosts}>
                    <div className="newsfeed__loader-center">
                        <Loader isLoading={true} Size="Large" />
                    </div>
                </ConditionalRender>
                <ConditionalRender if={!clubbedData.isLoading.fetchingPosts}>
                 <div className="px-xl">
                    {clubbedData.posts.map((post, index) => {
                        return (
                            <div key={post.id} style={{marginTop: index > 0 ? 'var(--space-l)' : 0}}>
                            <AiSummaryBox aiSummary={post.ai_summary} />
                            <a
                                href={post.shared_link.url}
                                target="_blank"
                                className="newsfeed__post-body"
                                key={post.id}
                            >
                                {post.shared_link.image_url &&
                                    <img
                                        src={post.shared_link.image_url}
                                        className="newsfeed__post-image"
                                        onError={handleNewsImageError}
                                    />
                                }
                                <div className="overflow-hidden">
                                    <TextHighlighter
                                        contentString={
                                            post.shared_link.title
                                        }
                                        toMatch={
                                            [post.tagged_prospects?.[0]?.name, post.tagged_prospects?.[0]?.company]
                                        }
                                        typography={{ className: "block no-underline body-m-bold newsfeed__post-title" }}
                                        style={{ marginBottom: 'var(--space-xs)' }}
                                    />
                                    <ConditionalRender if={post.type !== "Post::SecFiling"}>
                                        <Seemore
                                            short_description = {post.shared_link.short_description}
                                            description = {post.shared_link.description}
                                            person_name = {[post.tagged_prospects?.[0]?.name, post.tagged_prospects?.[0]?.company]}
                                            >
                                        </Seemore>
                                    </ConditionalRender>
                                    <div className="support-m color-text-secondary mt-s">
                                        <Link to={"/news_source/"+post.shared_link.source+"/feed"} className="link-default support-m">{post.shared_link.source}</Link>{" "}
                                        {post.shared_link.published_at
                                            ? `| ${post.shared_link.published_at}`
                                            : ""}
                                    </div>
                                </div>
                            </a>
                            </div>
                        )
                    })}
                    {props.renderSimilarArticles()}
                    </div>
                    <div className="newsfeed__clubbed-divider"></div>
                    <div className='px-xl'>
                    {props.renderCTAs()}
                    {props.renderCommentsSection()}
                    </div>
                    <div className="newsfeed__clubbed-divider-centered"></div>
                    <div className="flex items-center cursor-pointer justify-end" onClick={props.toggleExpansionCallback}>
                        <div className="body-m-semibold newsfeed__clubbed-collapse-text">Hide articles</div>
                        <img src={GreyArrowDown} className="newsfeed__clubbed-arrow-up"></img>
                    </div>
                </ConditionalRender>
            </ConditionalRender>
        </>

    )
}

const reducer = (state, action) => {
    switch(action.type){
        case "SET_STATE": {
            return {...state, ...action.payload}
        }
        default: return state
    }
}
export default ClubbedPost
